<template>
  <div class="similar-coupon-item">
    <component :is="isMobile ? 'q-item' : 'q-card'"
      :class="isMobile ? 'rounded-borders bg-grey-1' : 'similar-coupon-card cursor-pointer'"
      v-ripple
      clickable
      @click="$emit('view')"
    >
      <template v-if="isMobile">
        <q-item-section avatar>
          <store-logo
            :logo-url="coupon.store?.logo_url"
            :size="isMobile ? '46px' : '40px'"
            :custom-class="isMobile ? 'shadow-1' : 'q-mr-sm shadow-1'"
          />
        </q-item-section>
        <q-item-section>
          <q-item-label lines="1" class="text-weight-medium">{{ coupon.title }}</q-item-label>
          <q-item-label caption>
            <q-badge color="positive" outline>{{ discountDisplay }}</q-badge>
          </q-item-label>
        </q-item-section>
        <q-item-section side>
          <q-icon name="chevron_right" color="grey" />
        </q-item-section>
      </template>
      
      <template v-else>
        <q-card-section class="q-pa-sm">
          <div class="row items-start no-wrap">
            <store-logo
              :logo-url="coupon.store?.logo_url"
              size="40px"
              custom-class="q-mr-sm shadow-1"
            />
            <div class="column">
              <div class="text-subtitle2 ellipsis">{{ coupon.title }}</div>
              <q-badge color="positive" outline class="q-mt-xs">
                {{ discountDisplay }}
              </q-badge>
            </div>
          </div>
        </q-card-section>
        <q-card-actions align="right" class="q-pa-xs bg-grey-1">
          <q-btn flat color="primary" label="View Details" size="sm" />
        </q-card-actions>
      </template>
    </component>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
import StoreLogo from './StoreLogo.vue';

const props = defineProps({
  coupon: {
    type: Object,
    required: true
  },
  isMobile: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['view']);

const discountDisplay = computed(() => {
  if (!props.coupon) return '';
  return props.coupon.discount_value ? `${props.coupon.discount_value}% OFF` : '';
});
</script>

<style lang="scss" scoped>
.similar-coupon-card {
  border-radius: 8px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #f5f5f5;
    transform: translateY(-2px);
    box-shadow: 0 3px 8px rgba(0,0,0,0.1);
  }
}

.body--dark {
  .similar-coupon-card:hover {
    background-color: #2a2a2a;
  }
}
</style>
